import axios from "axios";
import apiUrl from "../../Apiurl";

const stampaFormatoPSdaIDsped = async function(token,ordiniSelezionati) {
    if (!token) {
        console.warn("sto aspettando un token")
        return;
    }
    try {
        const idSpedizioni = [...new Set(ordiniSelezionati
            .map(ord => typeof ord === "object" && ord !== null ? (ord.idSped || ord.id) : ord)
            .filter(id => /^\d+$/.test(String(id).trim()))
            .map(id => Number(id)))];

        if (!idSpedizioni.length) {
            console.warn("Nessuna spedizione valida da stampare");
            return;
        }

        const config = {
            headers: {
                'Authorization': 'Bearer ' + token,
            },
            responseType: 'blob',
        };
        const response = await axios.post(
            apiUrl + "/logistica/pdf/ordiniByIDPrestashopUnificati",
            { idSpedizioni },
            config,
        );

        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'ordini.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (err) {
        console.error('Errore durante il download del PDF', err);
        throw err;
    }
};

export default stampaFormatoPSdaIDsped;
